class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.desktopMediaQuery = window.matchMedia('(min-width: 990px)');
    this.hoverCloseTimeout = null;

    this.addEventListener('mouseenter', this.openOnHover.bind(this));
    this.summary.addEventListener('mouseenter', this.openOnHover.bind(this));
    this.summary.addEventListener('pointerenter', this.openOnHover.bind(this));
    this.addEventListener('mouseleave', this.closeOnHover.bind(this));
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onSummaryClick(event) {
    if (!this.desktopMediaQuery.matches || event.detail === 0) return;

    event.preventDefault();
  }

  openOnHover() {
    if (!this.desktopMediaQuery.matches) return;

    window.clearTimeout(this.hoverCloseTimeout);
    this.closeSiblingMenus();
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
  }

  closeOnHover() {
    if (!this.desktopMediaQuery.matches) return;

    this.hoverCloseTimeout = window.setTimeout(() => this.close(), 120);
  }

  closeSiblingMenus() {
    this.closest('.header__inline-menu')
      ?.querySelectorAll('header-menu')
      .forEach((menu) => {
        if (menu !== this) menu.close();
      });
  }
}

customElements.define('header-menu', HeaderMenu);

(() => {
  const desktopMediaQuery = window.matchMedia('(min-width: 990px)');
  const topLevelSummarySelector =
    '.header__inline-menu > .list-menu--inline > li > header-menu > details > summary';

  const closeMenu = (menu) => {
    const details = menu.querySelector('details');
    const summary = details?.querySelector('summary');

    window.clearTimeout(menu.hoverCloseTimeout);
    details?.removeAttribute('open');
    summary?.setAttribute('aria-expanded', false);
  };

  const openMenu = (menu) => {
    const details = menu.querySelector('details');
    const summary = details?.querySelector('summary');

    menu
      .closest('.header__inline-menu')
      ?.querySelectorAll('header-menu')
      .forEach((siblingMenu) => {
        if (siblingMenu !== menu) closeMenu(siblingMenu);
      });

    details?.setAttribute('open', '');
    summary?.setAttribute('aria-expanded', true);
  };

  const openTopLevelMenuOnHover = (event) => {
    if (!desktopMediaQuery.matches) return;

    const summary = event.target.closest(topLevelSummarySelector);
    if (!summary) return;

    openMenu(summary.closest('header-menu'));
  };

  document.addEventListener('pointerover', openTopLevelMenuOnHover);
  document.addEventListener('mouseover', openTopLevelMenuOnHover);
})();
